/**
 * CargaTempCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaTemp} from '@/model/resource/CargaTemp'

/* TODO: review generated class */
@HttpExclude()
export class CargaTempCollection extends PageCollection<CargaTemp> {
  constructor() {
    super(CargaTemp)
  }

  queryAsPage() {
    return this.listCargaTemp()
  }

  async listCargaTemp() {
    return await Request.get(`/admin/carga-temp`, {params: this.params})
      .name('listCargaTemp')
      .as(this)
      .getResponse()
  }

  async listCsvCargaTemp() {
    return await Request.get(`/admin/carga-temp/csv`, {params: this.params})
      .name('listCsvCargaTemp')
      .as(this)
      .getResponse()
  }
}
